module.exports = __webpack_public_path__ + "static/Politiche_sociali_EN-e46723c55b319ea67c8c23646750fd6e.png";